import { Injectable } from "@angular/core";
import { GoogleTagManagerService } from "angular-google-tag-manager";
import { environment } from "./../../environments/environment";
import { CurrentService } from "./current.service";
import { UserService } from "./user.service";
import { DatasService } from "./datas.service";

@Injectable()
export class GTM {
  private active: boolean = false;

  constructor(
    private gtmService: GoogleTagManagerService,
    private userService: UserService,
    private currentService: CurrentService,
    private dataService: DatasService
  ) { }

  public activate() {
    this.active = true;
    this.gtmService.addGtmToDom();
  }

  public trackPage(
    lvl1: string,
    lvl2?: string,
    lvl3?: string,
    customDatas?: any
  ) {
    if (!this.active) {
      return;
    }

    let layerData: any = {
      event: "virtual_pageview",
    };

    layerData.level1 = lvl1;
    if (lvl2) layerData.level2 = lvl2;
    if (lvl3) layerData.level3 = lvl3;

    this.pushGtm(layerData, customDatas);
  }

  public trackEvent(
    eventName: string,
    category: string,
    label: string,
    customDatas?: any
  ) {
    if (!this.active) {
      return;
    }

    let layerData: any = {
      event: eventName,
      category: category,
      label: label,
    };

    this.pushGtm(layerData, customDatas);
  }

  private pushGtm(layerData: any, customDatas?: any) {
    this.computePersistentCustomData()
      .then((persistentCustomData) => {
        for (const key in persistentCustomData) {
          layerData[key] = persistentCustomData[key];
        }

        if (customDatas) {
          for (const key in customDatas) {
            layerData[key] = customDatas[key];
          }
        }

        if (environment.gtm.enabled) {
          this.gtmService.pushTag(layerData);
        }

        if (environment.gtm.debug) {
          this._logLayerDataPush(layerData);
        }
      });
  }

  private computePersistentCustomData(): Promise<any> {
    return new Promise((resolve) => {
      let persistentCustomData: any = {
        user_type: 'anonymous',
        project_type: this.userService.context
      };

      if (this.currentService.sessionId) {
        persistentCustomData.session_id = this.currentService.sessionId;
      }

      if (this.userService.userDatas?.magentoId) {
        if (this.userService.userDatas?.vendor) {
          persistentCustomData.user_type = 'vendor';
          persistentCustomData.magento_user_id = this.userService.userDatas?.magentoId;
          persistentCustomData.store_id = this.userService.userDatas?.storeId;
        } else {
          persistentCustomData.user_type = 'customer';
        }
      }

      let promise = Promise.resolve('');
      if (this.currentService.project) {
        persistentCustomData.current_project_id = this.currentService.project.id;
        if (this.currentService.project.originalId) {
          persistentCustomData.original_project_id = this.currentService.project.originalId;
        } else {
          persistentCustomData.original_project_id = this.currentService.project.id;
        }
        // il faut chiffrer le nom du projet avant de le transmettre a GTM
        promise = this.dataService.encryptText(this.currentService.project.name)
          .then(encryptedProjectName => persistentCustomData.project_name = encryptedProjectName);
      }

      return promise.then(() => resolve(persistentCustomData));
    });
  }

  private _logLayerDataPush(layerData: any) {
    console.log("#######  DATALAYER #######");
    console.table(layerData);
  }
}
